import React from "react";
import {copyWithout} from "../../utils/copy-without";
import {useSearch} from "@okapi/router-react";

// TODO: убрать этот хардкод
export const ArticlesTabFilter = () => {
    const [search, setSearch] = useSearch();

    return (
        <div className="articles-tab-filter">
            {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment*/}
            {/* @ts-ignore */}
            <span onClick={() => setSearch(copyWithout(search, 'format'))}
                  className={`articles-tab-filter__item ${search.format ? '' : 'active'}`}>
                Все
            </span>
            <span onClick={() => setSearch({...search, format: 'video'})}
                  className={`articles-tab-filter__item ${search.format === 'video' ? 'active' : ''}`}>
                Видео
            </span>
            <span onClick={() => setSearch({...search, format: 'text'})}
                  className={`articles-tab-filter__item ${search.format === 'text' ? 'active' : ''}`}>
                Статьи
            </span>
        </div>
    )
}